import React, { Component } from 'react';
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card, Row, Col,Button } from 'reactstrap';
import { getFilterType } from './util';
import { SALES_RETURN, SALES_RETURN_DESCRIPTION } from '../constants';

class SaleReturnChart extends Component {

    state = {
        barChartProperties: { with_me_color: '', with_cug_member: '', cug_group_color: '' },
        selectedfilter: "Overall", filteredData : []
    }

    componentDidMount() {
       // console.log(this.props);
    }

    handleTypeFilter = (e) => {
        if (this.state.selectedfilter !== e.target.value) {
            this.setState({ selectedfilter: e.target.value }, ()=> {
                this.filterData();
            })
        }
        e.preventDefault();
    }

    filterData = () => {
        let type = getFilterType(this.state.selectedfilter);
        let filteredData = this.props.chartData.filter(objdata => objdata.type == type);
        this.setState({ filteredData: filteredData })
    }

    componentDidUpdate(prevProps){
        if(prevProps.chartData !== this.props.chartData){
            this.filterData();
        }
    }

    render() {
        return (
            <Card body className='mt-3' >
                <div>
                    <h3 className='text-center'>
                        {SALES_RETURN}
                    </h3>
                    {
                        this.props.typeFilters 
                        && this.props.typeFilters.length > 0 
                        && <select className='position-absolute chart-filter-dropdown' name="typefilter" onChange={(e) => this.handleTypeFilter(e)}>
                            {this.props.typeFilters.map(optionValue => (<option value={optionValue} key={Math.random()} selected={optionValue === this.state.selectedfilter ? true : false } >{optionValue}</option>))}
                        </select>
                    }
                </div>
                <ResponsiveContainer width='100%' height={300}>
                    <BarChart data={this.state.filteredData}
                        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}  >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="month" />
                        <YAxis />
                        <Tooltip />
                        <Legend style={{ marginTop: `5px !important` }} />
                        <Bar dataKey="me" fill="#5b9bd5" name= {`${this.props.counterpartyName} (With Me)`} />
                        <Bar dataKey="cug" fill="#ed7d31" name={`${this.props.counterpartyName} (With Other CUG Members)`} />
                    </BarChart>
                </ResponsiveContainer>
          
                <details>
                    <summary>
                        <i>Know more...</i>
                    </summary>
                    <p dangerouslySetInnerHTML={{ __html: SALES_RETURN_DESCRIPTION }}></p>
                </details>
            </Card>
        );
    }
}

export default SaleReturnChart;